import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-task-tab',
    templateUrl: './task-tab.component.html',
    styleUrls: ['./task-tab.component.scss'],
    standalone: false
})
export class TaskTabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  onTabChange(event){
  }
}
